/*eslint-disable sort-keys */
const savedSearchSortOrders = {
    LAST_SENT_ASCENDING: 'LAST_SENT_ASCENDING',
    LAST_SENT_DESCENDING: 'LAST_SENT_DESCENDING',
    RECENT_ITEM_ASCENDING: 'RECENT_ITEM_ASCENDING',
    RECENT_ITEM_DESCENDING: 'RECENT_ITEM_DESCENDING',
    SEARCH_TERM_ASCENDING: 'SEARCH_TERM_ASCENDING',
    SEARCH_TERM_DESCENDING: 'SEARCH_TERM_DESCENDING',
} as const;

export default savedSearchSortOrders;
